import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import zhCN from './locales/zh-CN';
import enUS from './locales/en-US';

// 语言资源
const resources = {
  'zh-CN': {
    translation: zhCN
  },
  'en-US': {
    translation: enUS
  }
};

// 初始化 i18n
i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem('language') || 'en-US', // 默认语言，从本地存储获取或使用英文
    fallbackLng: 'en-US', // 回退语言
    interpolation: {
      escapeValue: false // React 已经转义
    },
    react: {
      useSuspense: false // 禁用 Suspense
    }
  });

export default i18n;
